// Chakra imports
import { Box, Flex, useToast } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Assets
import { brandService } from 'api/services/brandService';
import { linkService } from 'api/services/linkService';
import profileAvatar from 'assets/icon/bumbei_iconoapp_RGB-01.png';
import ResultMessage from 'components/modal/ResultMessage';
import { NotificationToast } from 'components/toast/NotificationToast';
import { ALERT } from 'constant/messages';
import { storeActions } from 'store/store';
import { fetchData, handleCloseModal } from 'utils/hooks';
import { enrichRewardSteps } from 'utils/reward';
import Banner from 'views/client/welcome/components/Banner';

export default function Welcome() {
	const TOKEN = useSelector((state) => state.auth.tokenId);
	const dispatch = useDispatch();
	const toast = useToast();
	const [linkData, setLinkData] = useState([]);
	const [message, setMessage] = useState({
		state: false,
		status: '',
		description: '',
	});
	const { storeAllReward, storeAllLink, storeAllConversion } = useSelector(
		(state) => state.store
	);
	const { userLightningAddress, userReferrals } = useSelector(
		(state) => state.user
	);

	useEffect(() => {
		document.querySelector('.scroll-body')?.scrollTo(0, 0);
		const loadData = async () => {
			fetchData({
				apiCalls: [
					() => linkService.getAll(TOKEN),
					() => brandService.getAll(TOKEN),
				],
				setStates: [(data) => setLinkData(data)],
				setStores: [
					(data) => dispatch(storeActions.setStoreData({ storeAllLink: data })),
					(data) =>
						dispatch(storeActions.setStoreData({ storeAllBrand: data })),
				],
				alertMessages: ALERT,
				setMessage,
			});
		};

		loadData();
	}, []);

	useEffect(() => {
		if (!storeAllReward?.length) return;

		const alreadyEnriched = storeAllReward.every(
			(step) => typeof step.claimable === 'boolean'
		);

		if (alreadyEnriched) return;

		const enriched = enrichRewardSteps(storeAllReward, {
			userLightningAddress,
			userReferrals,
			storeAllLink,
			storeAllConversion,
		});

		dispatch(storeActions.setStoreData({ storeAllReward: enriched }));

		if (enriched.some((step) => step.claimable)) {
			toast({
				position: 'top-center',
				duration: 10000,
				isClosable: true,
				render: ({ onClose }) => (
					<NotificationToast
						title='¡Tienes recompensas disponibles!'
						description='Reclama tus sats completando tus acciones pendientes.'
						status='success'
						onClose={onClose}
					/>
				),
			});
		}
	}, [
		storeAllReward,
		userLightningAddress,
		userReferrals,
		storeAllLink,
		storeAllConversion,
	]);

	return (
		<Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
			<Box mb='20px' display={{ base: 'block', lg: 'grid' }}>
				<Flex flexDirection='column'>
					<Banner profile={profileAvatar} links={linkData.length} />
				</Flex>
			</Box>

			<ResultMessage
				isOpen={message.state}
				onClose={() => handleCloseModal(setMessage)}
				message={message}
			/>
		</Box>
	);
}
